import { IGPKeyInitiative } from 'legacy/lut/classes/models/partner360/IGPKeyInitiative'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

interface ICheckAffectedLP {
  ownerId: string
  partnerId: string
  programType: ProgramTypes | null
  fYear: number
  action: 'Create' | 'Update' | 'Delete'
  data: Partial<IGPKeyInitiative>
}
export const checkAffectedLP = async ({
  ownerId,
  partnerId,
  programType,
  fYear,
  action,
  data,
}: ICheckAffectedLP) => {
  const url = proxy('/webservice/621/sp/v3/spJBPKeyInitiativeApplyChangesCheckLP/call')
  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerId': partnerId,
    'p.ProgramType': programType,
    'p.FYear': fYear,
    'p.Action': action,
    'p.Data': JSON.stringify(data),
  }

  try {
    const response = await Rest.post({ url, payload, headers })
    return response.Rows
  } catch (e: any) {
    Logger.error('Error in checkAffectedLP', e)
    return null
  }
}
